/**
 *
 * TermsOfUse Component
 *
 */

import { stylize, Enums } from "@envestnet/envreact-component-library";
import Dialog from "components/TermsDialog";
import React from "react";
import withIntl from "utils/withIntl";
import dompurify from "dompurify";
import messages from "./messages";
import styles from "./styles";
import { TermsOfUseProps } from "./types";

type DefaultProps = {};

const defaultProps: DefaultProps = {};

const TermsOfUseDialog = ({
  classes,
  open,
  setOpen,
  fileDetails,
  setTermsAndCondition,
  formatMessage,
}: TermsOfUseProps) => {
  const rawHTML = dompurify.sanitize(fileDetails as string, {
    FORCE_BODY: true,
  });

  const buttons = [
    {
      buttonType: Enums.ButtonStyle.Secondary,
      title: formatMessage(messages.cancelButtonLabel),
      id: formatMessage(messages.cancelButtonLabel),
      onClick: () => {
        setOpen(false);
        setTermsAndCondition(false);
      },
    },
    {
      buttonType: Enums.ButtonStyle.Primary,
      title: formatMessage(messages.termsAgree),
      id: formatMessage(messages.termsAgree),
      reachedBottom: true,
      onClick: () => {
        setOpen(false);
        setTermsAndCondition(true);
      },
    },
  ];

  const renderAsHtml = () => (
    // eslint-disable-next-line react/no-danger
    <div className="header-text-font-family" dangerouslySetInnerHTML={{ __html: rawHTML }}></div> // NOTE: uploaded File is sanitized
  );

  return (
    <Dialog
      open={open}
      onClose={() => {
        setOpen(false);
        setTermsAndCondition(false);
      }}
      title={formatMessage(messages.termsAndConditionHeader)}
      styleObject={{ container: classes.containerStyle }}
      buttons={buttons}
      enableButtonDisabled
      isSticky
    >
      {renderAsHtml()}
    </Dialog>
  );
};

TermsOfUseDialog.defaultProps = defaultProps;

export default withIntl(
  stylize<TermsOfUseProps, DefaultProps>(styles)(TermsOfUseDialog)
);
